import React, { useState } from "react";
import Navbar from "../NavBar";
import { Layout, Typography, Row, Col } from "antd";
import Footer from "../Footer";
import { CheckCircleOutlined } from '@ant-design/icons';
import JobSeekerFeatures from "../JobSeekerFeatures";
import Popup from "../popup";

const { Content } = Layout;
const { Title, Text } = Typography;

const ForJobSeekers = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const showModal = () => {
    setModalVisible(true);
  };

  const handleClose = () => {
    setModalVisible(false);
  };

  const signInUser = (pathName) => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const isLocalhost = baseUrl.includes('localhost') || baseUrl.includes('127.0.0.1');
    const protocol = isLocalhost ? 'http://' : 'https://';
    const cleanBaseUrl = baseUrl.replace(/^https?:\/\//, '');
    const redirectTo = `${protocol}${cleanBaseUrl}/${pathName}?path=finishSignup`;
    window.location.href = redirectTo;
  };

  const handleCreateProfile = () => {
    const path = process.env.REACT_APP_OFFICE_AUTH_ENDPOINT;
    setLoading(true);
    if (path) signInUser(path);
  };

  return (
    <div>
      {/* Add modern animation styles */}
      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px) rotate(45deg);
          }
          50% {
            transform: translateY(-20px) rotate(45deg);
          }
        }
        
        @keyframes floatReverse {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(15px);
          }
        }
      `}</style>
      {/* Header */}
      <div className="landing-page-content">
        <Layout className="layout" style={{ position: 'relative' }}>
          <Navbar />
          <Content>
            {/* Hero Section - Job Seeker Focused */}
            <div className="hero-section" style={{
              background: `
                radial-gradient(circle at 20% 50%, rgba(104, 65, 235, 0.08) 0%, transparent 50%),
                radial-gradient(circle at 80% 20%, rgba(209, 189, 33, 0.08) 0%, transparent 50%),
                radial-gradient(circle at 40% 80%, rgba(59, 130, 246, 0.08) 0%, transparent 50%),
                linear-gradient(135deg, #f0f2f5 0%, #f8fafc 50%, #f1f5f9 100%)
              `,
              position: 'relative',
              overflow: 'hidden',
              paddingTop: '80px'
            }}>
              <div className="hero-container">
                {/* Modern Floating Elements */}
                <div style={{
                  position: 'absolute',
                  top: '10%',
                  right: '10%',
                  width: '120px',
                  height: '120px',
                  background: 'linear-gradient(135deg, rgba(104, 65, 235, 0.1), rgba(59, 130, 246, 0.1))',
                  borderRadius: '30px',
                  transform: 'rotate(45deg)',
                  zIndex: 0,
                  animation: 'float 6s ease-in-out infinite'
                }}></div>
                
                <div style={{
                  position: 'absolute',
                  top: '60%',
                  left: '5%',
                  width: '80px',
                  height: '80px',
                  background: 'linear-gradient(135deg, rgba(209, 189, 33, 0.15), rgba(255, 193, 7, 0.1))',
                  borderRadius: '50%',
                  zIndex: 0,
                  animation: 'float 8s ease-in-out infinite reverse'
                }}></div>
                
                <div style={{
                  position: 'absolute',
                  top: '20%',
                  left: '15%',
                  width: '60px',
                  height: '60px',
                  background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(147, 197, 253, 0.1))',
                  borderRadius: '12px',
                  transform: 'rotate(30deg)',
                  zIndex: 0,
                  animation: 'float 10s ease-in-out infinite'
                }}></div>
                
                <div style={{
                  position: 'absolute',
                  bottom: '10%',
                  right: '20%',
                  width: '100px',
                  height: '100px',
                  background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(52, 211, 153, 0.1))',
                  borderRadius: '50% 10px',
                  zIndex: 0,
                  animation: 'float 7s ease-in-out infinite'
                }}></div>
                <h1 className="hero-title" style={{ position: 'relative', zIndex: 10 }}>
                  <span className="gradient-word">One Profile</span>, Endless <span className="gradient-word">Opportunities</span>
                </h1>
                
                <div className="hero-description" style={{ fontSize: '20px', lineHeight: '1.6', maxWidth: '750px', margin: '0 auto 35px auto', position: 'relative', zIndex: 10 }}>
                  <p style={{ marginBottom: '30px', fontWeight: '500', color: '#333', fontSize: '22px' }}>
                    Your dedicated workspace with one smart profile for all applications. See live status updates, get specific feedback, and schedule interviews automatically. Get instantly matched and notified for new openings at every company you already applied to with a matching score. Complete transparency throughout the hiring process with tools designed just for job seekers.
                  </p>
                </div>

                {/* Key Benefits for Job Seekers */}
                <Row gutter={[24, 16]} style={{ marginTop: 0, textAlign: 'center', marginBottom: 40, position: 'relative', zIndex: 10 }}>
                  <Col xs={24} sm={8}>
                    <div className="trial-content">
                      <CheckCircleOutlined style={{ color: 'green', marginRight: 8, fontSize: '20px' }} />
                      <Text style={{ fontSize: '16px', fontWeight: '600' }}>100% Free for Job Seekers</Text>
                    </div>
                  </Col>
                  <Col xs={24} sm={8}>
                    <div className="trial-content">
                      <CheckCircleOutlined style={{ color: 'green', marginRight: 8, fontSize: '20px' }} />
                      <Text style={{ fontSize: '16px', fontWeight: '600' }}>No Hidden Fees</Text>
                    </div>
                  </Col>
                  <Col xs={24} sm={8}>
                    <div className="trial-content">
                      <CheckCircleOutlined style={{ color: 'green', marginRight: 8, fontSize: '20px' }} />
                      <Text style={{ fontSize: '16px', fontWeight: '600' }}>Instant Access</Text>
                    </div>
                  </Col>
                </Row>

                <div style={{ 
                  textAlign: 'center', 
                  marginTop: '30px', 
                  position: 'relative', 
                  zIndex: 10,
                  display: 'flex',
                  gap: '16px',
                  justifyContent: 'center',
                  flexWrap: 'wrap'
                }}>
                  <button 
                    style={{
                      background: '#d1bd21',
                      color: 'black',
                      border: 'none',
                      padding: '16px 32px',
                      borderRadius: '8px',
                      fontSize: '18px',
                      fontWeight: '600',
                      cursor: 'pointer',
                      minWidth: '180px'
                    }}
                    onClick={() => window.location.href = '/job-board'}
                  >
                    Browse Jobs Now
                  </button>
                  <button 
                    style={{
                      background: 'transparent',
                      color: '#6841eb',
                      border: '2px solid #6841eb',
                      padding: '16px 32px',
                      borderRadius: '8px',
                      fontSize: '18px',
                      fontWeight: '600',
                      cursor: 'pointer',
                      minWidth: '180px'
                    }}
                    onClick={handleCreateProfile}
                    disabled={loading}
                  >
                    Create Profile
                    {loading && <span style={{ marginLeft: '8px' }}>...</span>}
                  </button>
                </div>
              </div>
            </div>
          </Content>
        </Layout>
      </div>

      {/* Modern Job Seeker Features */}
      <JobSeekerFeatures />

      {/* Dashboard Preview */}
      <div style={{ padding: "80px 20px", background: "#f0f2f5" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center" }}>
          <Title level={2} style={{ color: "#6841eb", marginBottom: "20px", fontSize: "2.5rem" }}>
            Your Personal Job Search Dashboard
          </Title>
          <Text style={{ fontSize: "18px", color: "#666", marginBottom: "40px", display: "block" }}>
            Everything you need to manage your job search in one place
          </Text>
          
          <div style={{ marginTop: "40px" }}>
            <img 
              src="/candidatedashboard.png" 
              alt="Job Seeker Dashboard"
              style={{ width: "100%", maxWidth: "1200px", borderRadius: "12px", boxShadow: "0 8px 32px rgba(0,0,0,0.1)" }}
            />
          </div>
        </div>
      </div>

      {/* Closing CTA Section for Job Seekers */}
      <div style={{ background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)", padding: "80px 20px", textAlign: "center" }}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <Title level={2} style={{ color: "white", marginBottom: "24px", fontSize: "2.5rem", fontWeight: "800" }}>
            Ready to Find Your Dream Job?
          </Title>
          <Text style={{ color: "rgba(255,255,255,0.9)", fontSize: "20px", display: "block", marginBottom: "40px", lineHeight: "1.6" }}>
            Join thousands of job seekers who've found better opportunities faster with ChronoFlow. Create your profile and start applying to jobs in minutes.
          </Text>
          
          {/* Benefits */}
          <Row gutter={[32, 16]} style={{ marginBottom: "48px", justifyContent: "center" }}>
            <Col xs={24} sm={8}>
              <div style={{ textAlign: "center" }}>
                <CheckCircleOutlined style={{ color: "#d1bd21", fontSize: "24px", marginBottom: "8px" }} />
                <Text style={{ color: "white", fontSize: "16px", fontWeight: "600", display: "block" }}>
                  100% Free Forever
                </Text>
              </div>
            </Col>
            <Col xs={24} sm={8}>
              <div style={{ textAlign: "center" }}>
                <CheckCircleOutlined style={{ color: "#d1bd21", fontSize: "24px", marginBottom: "8px" }} />
                <Text style={{ color: "white", fontSize: "16px", fontWeight: "600", display: "block" }}>
                  Setup in 2 Minutes
                </Text>
              </div>
            </Col>
            <Col xs={24} sm={8}>
              <div style={{ textAlign: "center" }}>
                <CheckCircleOutlined style={{ color: "#d1bd21", fontSize: "24px", marginBottom: "8px" }} />
                <Text style={{ color: "white", fontSize: "16px", fontWeight: "600", display: "block" }}>
                  Start Applying Instantly
                </Text>
              </div>
            </Col>
          </Row>

          {/* CTA Buttons */}
          <div style={{ display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap" }}>
            <button 
              style={{
                background: "#d1bd21",
                color: "black",
                border: "none",
                padding: "18px 36px",
                borderRadius: "8px",
                fontSize: "18px",
                fontWeight: "700",
                cursor: "pointer",
                transition: "all 0.3s ease",
                minWidth: "180px"
              }}
              onMouseOver={(e) => e.target.style.background = "#b8a01d"}
              onMouseOut={(e) => e.target.style.background = "#d1bd21"}
              onClick={() => window.location.href = '/job-board'}
            >
              Browse Jobs Now
            </button>
            <button 
              style={{
                background: "transparent",
                color: "white",
                border: "2px solid white",
                padding: "18px 36px",
                borderRadius: "8px",
                fontSize: "18px",
                fontWeight: "700",
                cursor: "pointer",
                transition: "all 0.3s ease",
                minWidth: "180px"
              }}
              onMouseOver={(e) => {
                e.target.style.background = "white";
                e.target.style.color = "#764ba2";
              }}
              onMouseOut={(e) => {
                e.target.style.background = "transparent";
                e.target.style.color = "white";
              }}
              onClick={handleCreateProfile}
              disabled={loading}
            >
              Create Profile
              {loading && <span style={{ marginLeft: '8px' }}>...</span>}
            </button>
          </div>

          <Text style={{ color: "rgba(255,255,255,0.8)", fontSize: "14px", marginTop: "24px", display: "block" }}>
            Questions? 
            <span 
              onClick={showModal}
              style={{ 
                color: "#d1bd21", 
                cursor: "pointer", 
                textDecoration: "underline",
                marginLeft: "4px"
              }}
            >
              Contact Us
            </span>
          </Text>
        </div>
      </div>

      <Footer />
      
      {/* Contact Modal */}
      <Popup visible={modalVisible} onClose={handleClose} />
    </div>
  );
};

export default ForJobSeekers;